/* eslint-disable */
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const OtherCostBarLine = ({ datasets, chartData, title }) => {
  const data = {
    labels: chartData.map((item) => item.month),
    datasets: datasets,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    layout: {
      padding: {
        top: 20,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (ctx) => {
            const val = ctx.parsed?.y ?? ctx.raw;
            return `${ctx.dataset.label}: ${val} Lac`;
          },
        },
      },
      datalabels: {
        color: "black",
        textStrokeColor: "white",
        textStrokeWidth: 4,
        anchor: "end",
        align: "end",
        // rotation: 90, 
        // display: "auto",
        // clip: "auto",
        font: {
          weight: "bold",
          size: 10,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          display:true,
          font: { size: 8 },
          // callback: (value) => `${value} Lac`,
        },
        grid: { display: true },
      },
      x: {
        ticks: {
          display: true,
          font: { size: 9 },
        },
      },
    },
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "230px", width: "100%" }}
    >
      <Chart data={data} options={options} />
    </div>
  );
};

export default OtherCostBarLine;
